"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { getTimeAgoShort } from "@/helpers/Helpers";
interface BrainLeftSidebarWaveDropTimeProps {
  readonly time: number;
}
const BrainLeftSidebarWaveDropTime: React.FC<BrainLeftSidebarWaveDropTimeProps> = t0 => {
  const $ = _c(10);
  const {
    time
  } = t0;
  const [now, setNow] = useState(_temp);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const intervalId = window.setInterval(() => {
        setNow(Date.now());
      }, 60000);
      return () => {
        window.clearInterval(intervalId);
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setNow(_temp2);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== time) {
    t4 = [time];
    $[3] = time;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== now || $[6] !== time) {
    t5 = getTimeAgoShort(time, now);
    $[5] = now;
    $[6] = time;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const label = t5;
  let t6;
  if ($[8] !== label) {
    t6 = <span className="tw-text-iron-300">{label}</span>;
    $[8] = label;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
export default BrainLeftSidebarWaveDropTime;
function _temp() {
  return Date.now();
}
function _temp2(previousNow) {
  const currentNow = Date.now();
  return previousNow === currentNow ? previousNow : currentNow;
}